export default __webpack_public_path__ + "img/robotic-hand.289cbcc1.png";